function addItemToCart(variant_id, qty, frequency, unit_type) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
    document.dispatchEvent(new CustomEvent('cart:build'));
      }
    });
 document.dispatchEvent(new CustomEvent('cart:build'));
  }

document.addEventListener('variant-change', function(evt) {

  var varQty = $('.variant-selection__variants option[value="'+evt.detail.variant.id+'"]').attr("data-quantity");
  if($('.is-preorder').length){
  if (varQty > 0 ){
    $('.add_to_cart .text').text('Add to Cart');
  } else {
    $('.add_to_cart .text').text('PREORDER');
  }
  }
});